'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeInvolvement(name, status, role, outOfOffice) {
  this.Lapp_data_GeneralPracticeInvolvement__f_name = null;
  this.Lapp_data_GeneralPracticeInvolvement__f_status = null;
  this.Lapp_data_GeneralPracticeInvolvement__f_role = null;
  this.Lapp_data_GeneralPracticeInvolvement__f_outOfOffice = null;
  this.Lapp_data_GeneralPracticeInvolvement__f_name = name;
  this.Lapp_data_GeneralPracticeInvolvement__f_status = status;
  this.Lapp_data_GeneralPracticeInvolvement__f_role = role;
  this.Lapp_data_GeneralPracticeInvolvement__f_outOfOffice = outOfOffice;
}
export { $c_Lapp_data_GeneralPracticeInvolvement as $c_Lapp_data_GeneralPracticeInvolvement };
$c_Lapp_data_GeneralPracticeInvolvement.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeInvolvement.prototype.constructor = $c_Lapp_data_GeneralPracticeInvolvement;
/** @constructor */
function $h_Lapp_data_GeneralPracticeInvolvement() {
}
export { $h_Lapp_data_GeneralPracticeInvolvement as $h_Lapp_data_GeneralPracticeInvolvement };
$h_Lapp_data_GeneralPracticeInvolvement.prototype = $c_Lapp_data_GeneralPracticeInvolvement.prototype;
$c_Lapp_data_GeneralPracticeInvolvement.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_GeneralPracticeInvolvement.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 762308508, true);
});
$c_Lapp_data_GeneralPracticeInvolvement.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_GeneralPracticeInvolvement)) {
    if ((this.Lapp_data_GeneralPracticeInvolvement__f_name === x$0.Lapp_data_GeneralPracticeInvolvement__f_name)) {
      var x = this.Lapp_data_GeneralPracticeInvolvement__f_status;
      var x$2 = x$0.Lapp_data_GeneralPracticeInvolvement__f_status;
      var $x_2 = (x === x$2);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lapp_data_GeneralPracticeInvolvement__f_role;
      var x$4 = x$0.Lapp_data_GeneralPracticeInvolvement__f_role;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lapp_data_GeneralPracticeInvolvement__f_outOfOffice;
      var x$6 = x$0.Lapp_data_GeneralPracticeInvolvement__f_outOfOffice;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_data_GeneralPracticeInvolvement.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_GeneralPracticeInvolvement.prototype.productArity__I = (function() {
  return 4;
});
$c_Lapp_data_GeneralPracticeInvolvement.prototype.productPrefix__T = (function() {
  return "GeneralPracticeInvolvement";
});
$c_Lapp_data_GeneralPracticeInvolvement.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_data_GeneralPracticeInvolvement__f_name;
      break;
    }
    case 1: {
      return this.Lapp_data_GeneralPracticeInvolvement__f_status;
      break;
    }
    case 2: {
      return this.Lapp_data_GeneralPracticeInvolvement__f_role;
      break;
    }
    case 3: {
      return this.Lapp_data_GeneralPracticeInvolvement__f_outOfOffice;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_GeneralPracticeInvolvement.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "status";
      break;
    }
    case 2: {
      return "role";
      break;
    }
    case 3: {
      return "outOfOffice";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_GeneralPracticeInvolvement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_GeneralPracticeInvolvement)));
}
export { $isArrayOf_Lapp_data_GeneralPracticeInvolvement as $isArrayOf_Lapp_data_GeneralPracticeInvolvement };
var $d_Lapp_data_GeneralPracticeInvolvement = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeInvolvement, "app.data.GeneralPracticeInvolvement", ({
  Lapp_data_GeneralPracticeInvolvement: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_GeneralPracticeInvolvement as $d_Lapp_data_GeneralPracticeInvolvement };
//# sourceMappingURL=app.data.-General-Practice-Involvement.js.map
